import {} from 'ramda'

class TimestampController {
  /* @ngInject */
  constructor (job, timestamps, $scope, $mdDialog, NgMap, user, minOffsite) {
    this.$scope = $scope
    this.$mdDialog = $mdDialog
    this.NgMap = NgMap
    this.minOffsite = minOffsite
    this.timestamps = timestamps
    this.job = job
    this.user = user
    this.map = {
      center: {
        latitude: this.job.latitude,
        longitude: this.job.longitude
      },
      zoom: 13
    }
    NgMap.getMap({id: 'map'}).then(function (map) {
    })
  }

  close () {
    this.$mdDialog.cancel()
  }
}

export default TimestampController
